module.exports = __webpack_public_path__ + "static/headerImage-e20a83911415c24d66de588945854822.jpg";